module.exports = __webpack_public_path__ + "static/media/svg-1.09b810ef.svg";